// This code is for cart drawer
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }
setHeaderCartIconAccessibility() {
  const cartLink =
    document.querySelector(".header_cart_is_drawer") ||
    document.querySelector(".header_cart");

  if (!cartLink) return;

  cartLink.setAttribute("role", "button");
  cartLink.setAttribute("aria-haspopup", "dialog");

  const openCart = (event) => {
    event.preventDefault();
    this.open(cartLink);
  };

  cartLink.addEventListener("click", openCart);
  cartLink.addEventListener("keydown", (event) => {
    if (event.code.toUpperCase() === "SPACE" || event.code === "Enter") {
      openCart(event);
    }
  });
}

  // close sidecart
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    const cartDrawer = document.querySelector(".drawer_cart");
    const focusableElements = cartDrawer.querySelectorAll(
      "button, input, a, .cart-drawer, summary, cart-item-list"
    ); // Interactive elements

    focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
  }

  // setSummaryAccessibility
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

   
  renderContents(parsedState) {
    const drawerInner = this.querySelector(".drawer__inner");
    drawerInner.classList.contains("is-empty") &&
    drawerInner.classList.remove("is-empty");
      
    this.productId = parsedState.id;

    if(Shopify.designMode) {
      window.location.href = Shopify.routes.root + 'cart/';
    }
    
    this.getSectionsToRender().forEach(({ id, selector }) => {
      const sectionElement = selector
        ? document.querySelector(selector)
        : document.getElementById(id);
      sectionElement.innerHTML = this.getSectionHTML(
        parsedState.sections[id],
        selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });

    const cartUpdatedEvent = new CustomEvent("cart:updated", {
          detail: {
            cartData: parsedState,
          },
        });
        window.dispatchEvent(cartUpdatedEvent);
  }


  // getSectionHTML
  getSectionHTML(html, selector = ".shopify-section") {
    const section = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    return section ? section.innerHTML : "";
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-item-list", CartDrawerItems);

// CART DRAWER ACCESSIBILITY
document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector(".drawer_cart");
  if (!cartDrawer) return;
  const DrawerInner = cartDrawer.querySelector(".drawer__inner");
  const focusableElements = cartDrawer.querySelectorAll(
    "button, input, a, .cart-drawer, summary, cart-item-list"
  ); // Interactive elements
  const closeButton = cartDrawer.querySelector(".cart-close"); // Update selector

  function disableSearchFocus() {
    focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
  }

  function opencartDrawer(event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault();
      cartDrawer.classList.add("active");
      cartDrawer.setAttribute("aria-hidden", "false");

      // Enable focus
      focusableElements.forEach((el) => el.setAttribute("tabindex", "0"));
      trapFocus(cartDrawer, DrawerInner);
    }
  }

  function closecartDrawer() {
    cartDrawer.classList.remove("active");
    cartDrawer.setAttribute("aria-hidden", "true");

    disableSearchFocus();
  }

  disableSearchFocus();

  closeButton.addEventListener("click", closecartDrawer);
  cartDrawer.addEventListener("keydown", function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      closecartDrawer();
    }
  });
});
